import React from 'react';
import { Link } from 'react-router-dom';
import './News.css';

const News = ({ data }) => {
    // Show only the 3 most recent news items on homepage
    const recentNews = data.items.slice(0, 3);

    return (
        <section className="news section bg-light" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>
                <p className="section-intro">{data.intro}</p>

                <div className="news-grid">
                    {recentNews.map((item, index) => (
                        <div key={item.slug} className="news-card">
                            <div className="news-image">
                                <img src={item.image} alt={item.imageAlt} />
                                <span className={`news-label ${item.variant}`}>
                                    {item.label}
                                </span>
                            </div>
                            <div className="news-content">
                                <div className="news-date">
                                    <i className="fas fa-calendar-alt"></i>
                                    {item.date}
                                </div>
                                <h3>{item.title}</h3>
                                <p>{item.summary}</p>
                                <Link to={`/news/${item.slug}`} className="news-link">
                                    Read More <i className="fas fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center" style={{ marginTop: '40px' }}>
                    <Link to="/news" className="btn btn-primary">
                        <i className="fas fa-newspaper"></i> View All News
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default News;
